import { render, staticRenderFns } from "./ServiceNoticeView.vue?vue&type=template&id=602060b1"
import script from "./ServiceNoticeView.vue?vue&type=script&lang=js"
export * from "./ServiceNoticeView.vue?vue&type=script&lang=js"
import style0 from "./ServiceNoticeView.vue?vue&type=style&index=0&id=602060b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports